import * as React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import nb from 'date-fns/locale/nb';
import { Either } from 'purify-ts';
import { Language } from '../utils/language';
import { Left, Right } from 'purify-ts';
import { date, Codec } from 'purify-ts/Codec';
import { format } from 'date-fns';

interface DatePickerConfig {
  selectDate: React.Dispatch<any>;
  currentDate: Either<string, string>;
  language: Language;
  variant?: 'standard' | 'outlined' | 'filled';
}

export function SharedDatePicker({ selectDate, currentDate, language, variant = 'filled' }: DatePickerConfig) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={nb}>
      <KeyboardDatePicker
        style={{ width: '100%' }}
        required
        disableToolbar
        variant="inline"
        inputVariant={variant}
        format="yyyy-MM-dd"
        margin="normal"
        id="date-picker-inline"
        label="Gyldighetsdato for uttak fra NVDB"
        value={currentDate.isRight() ? currentDate.extract() : undefined}
        // maxDate={new Date()}
        onChange={date => {
          const decodedDate = dateCodec(language).decode(date?.toString());
          selectDate(decodedDate);
        }}
        error={currentDate.isLeft()}
        helperText={currentDate.leftOrDefault('')}
        KeyboardButtonProps={{
          'aria-label': 'Kalender: Velg gyldighetsdato for uttak fra NVDB',
        }}
      />
    </MuiPickersUtilsProvider>
  );
}

export function formatDate(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function dateCodec(language: Language): Codec<string> {
  const error = language === 'nb_NO' ? nbError : nnError;
  return Codec.custom<string>({
    decode: (input: unknown) => {
      const decodedDate = date.decode(input);

      return decodedDate.chain(inputDate => {
        // const today = new Date();
        // const newerThanToday = today.getTime() < inputDate.getTime();

        return Right(formatDate(inputDate));
      });
    },
    encode: input => input,
  });
}

interface DateErrors {
  notValid: string;
  notLaterThanToday: string;
}

const nbError: DateErrors = {
  notValid: 'Dato er ikke gitt',
  notLaterThanToday: 'Dato kan senest være dagens dato',
};

const nnError: DateErrors = {
  notValid: 'Dato er ikke gitt',
  notLaterThanToday: 'Dato kan senest være dagens dato',
};
